module.exports = __webpack_public_path__ + "img/matchDay.9e0b742c.svg";